import { Button, Checkbox, Form, Input, message, Modal } from "antd";
import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";

const ContactModal = (props) => {
  const form = useRef();
  const handleOk = () => {
    props.setVisible(false);
  };
  const handleCancel = () => {
    props.setVisible(false);
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_gm9ntm8",
        "template_7pbe3pq",
        form.current,
        "jZJJD8r-f0ANE4xyM"
      )
      .then(
        (result) => {
          console.log(result.text);
          console.log("message sent!!");
          document.getElementById("myForm").reset();
          message.success("message sent!");
          handleCancel();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className=" modal-body">
      <Modal
        // className="text-gray-400"
        title="Write me a message"
        visible={props.visible}
        setVisible={props.setVisible}
        // onOk={handleOk}
        // onCancel={handleCancel}
        footer={null}
        wrapClassName="customBackground"
      >
        <form id="myForm" ref={form} onSubmit={sendEmail}>
          <div className="flex flex-col w-full h-full gap-6 mt-10">
            <div className="flex flex-row h-[32px] w-full justify-center items-center">
              <label className="w-1/5 text-gray-400 text-xl ">Name:</label>
              <input
                className="w-4/5 bg-[#555B69] rounded-lg text-xl p-2 text-left text-white"
                type="text"
                name="user_name"
              />
            </div>
            <div className="flex flex-row h-[32px] w-full justify-center items-center">
              <label className="w-1/5 text-gray-400 text-xl">Email:</label>
              <input
                className="w-4/5 bg-[#555B69] rounded-lg text-xl p-2 text-left text-white"
                type="email"
                name="user_email"
              />
            </div>
            <div className="flex flex-row  w-full justify-center items-start">
              <label className="w-1/5 text-gray-400  text-xl">Message:</label>
              <textarea
                className="w-4/5 bg-[#555B69] rounded-lg text-xl p-2 text-left text-white"
                name="message"
                rows="4"
                cols="50"
              />
            </div>
          </div>
          <div className="flex w-full mt-5 justify-end">
            <input
              type="submit"
              value="Send"
              className="rounded-md w-1/3 bg-[#555B69] cursor-pointer text-center h-10 text-gray-400 text-xl"
            />
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default ContactModal;
